const strings = {
  WARNING_MESSAGE:
    "Users will see this announcement on every page load, please use this carefully as it will disrupt the user's experience. Ensure that a valid expiry date and time is set. ",
};

export default strings;
